import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteUnitCustomZone = async (zoneId: number): Promise<boolean> =>
  axios.delete(`/my-monitoring/sites/RemoveZone?zoneId=${zoneId}`).then((res) => res?.data?.result)

type Props = {
  zoneId: number
}

export const useMyMonitoringDeleteSiteZone = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteMyMonitoringSiteZone'],
    mutationFn: ({ zoneId }: Props) => deleteUnitCustomZone(zoneId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Zone deleted.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to delete zone, please try again.')
      }
    },
    throwOnError: false
  })
